import { useQuery } from "@tanstack/react-query";
import { LuEllipsis } from "react-icons/lu";
import { RadialBarChart, RadialBar, ResponsiveContainer } from "recharts";
import { getUserCount } from "../../services/userService";

const LuEllipsisIcon = LuEllipsis as React.ElementType;

export const CountChart = () => {
  const { data: userCount, isLoading: loadingUsers } = useQuery({
    queryKey: ["users"],
    queryFn: getUserCount,
  });

  const data = [
    {
      name: "Total",
      count:
        (userCount?.totalProfessionals ?? 0) + (userCount?.totalEmployers ?? 0),
      fill: "white",
    },
    {
      name: "Professionals",
      count: loadingUsers ? 0 : userCount?.totalProfessionals ?? 0,
      fill: "#c7d2fe",
    },
    {
      name: "Employers",
      count: loadingUsers ? 0 : userCount?.totalEmployers ?? 0,
      fill: "#bae6fd",
    },
  ];

  return (
    <div className="rounded-2xl w-full h-full p-4 border">
      <div className="flex items-center justify-between">
        <h1 className="text-lg font-semibold">Users</h1>
        <LuEllipsisIcon />
      </div>
      {/* CHART */}
      <div className="relative w-full h-[75%] -z-10">
        <ResponsiveContainer>
          <RadialBarChart
            cx="50%"
            cy="50%"
            innerRadius="40%"
            outerRadius="100%"
            barSize={32}
            data={data}
          >
            <RadialBar background dataKey="count" />
          </RadialBarChart>
        </ResponsiveContainer>
        <div className="w-12 h-12 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
          <img src="/users.png" alt="" className="" />
        </div>
      </div>
      {/* BOTTOM */}
      <div className="flex justify-center space-x-4">
        <div className="flex flex-col space-y-1">
          <div className="w-[12px] h-[12px] rounded-full bg-indigo-200" />
          <span className="font-bold">
            {userCount?.totalProfessionals ?? 0}
          </span>
          <div className="text-xs text-gray-500">
            Professionals (
            {Math.round(
              ((userCount?.totalProfessionals ?? 0) /
                ((userCount?.totalProfessionals ?? 0) +
                  (userCount?.totalEmployers ?? 0))) *
                100
            ) || 0}
            %)
          </div>
        </div>
        <div className="flex flex-col space-y-1">
          <div className="w-[12px] h-[12px] rounded-full bg-sky-200" />
          <h1 className="font-bold">{userCount?.totalEmployers ?? 0}</h1>
          <div className="text-xs text-gray-500">
            Employers (
            {Math.round(
              ((userCount?.totalEmployers ?? 0) /
                ((userCount?.totalProfessionals ?? 0) +
                  (userCount?.totalEmployers ?? 0))) *
                100
            ) || 0}
            %)
          </div>
        </div>
      </div>
    </div>
  );
};
